export default {
    methods: {
        judgeCorrect(selected, selection, correctAnswer) {
            return (
                selected !== undefined
                && selection === correctAnswer
            );
        },
        judgeIncorrect(selected, selection, correctAnswer) {
            return (
                correctAnswer !== undefined
                && selected === selection
                && selection !== correctAnswer
            );
        },
    },
};
